import '../elitePlansTheme.css'
import {
  ELITE_PLANS_ELITE_TAB_ID,
  ElitePlansLandingProvider,
  useElitePlansLanding
} from '../ElitePlansLandingContext'
import { ElitePlansAnalyticsScreen } from '../constants/analyticsEvents'
import { ElitePlansTabbedPageLayout } from '../components/ElitePlansTabbedPageLayout'
import { ElitePlansSellBody } from '../components/ElitePlansSellBody'
import { ElitePlansEliteMemberDashboard } from '../components/ElitePlansEliteMemberDashboard'
import { useTrackElitePlansScreenLoadWhenReady } from '../hooks/useTrackElitePlansScreenLoadWhenReady'

export default function ElitePlansMemberPage() {
  return (
    <ElitePlansLandingProvider analyticsScreen={ElitePlansAnalyticsScreen.Member}>
      <ElitePlansMemberPageContent />
    </ElitePlansLandingProvider>
  )
}

function ElitePlansMemberPageContent() {
  const { selectedPlanId, isStatusLoading } = useElitePlansLanding()
  const showEliteDashboard = selectedPlanId === ELITE_PLANS_ELITE_TAB_ID

  // Elite dashboard fires ScreenLoaded when its own advisory status is ready
  useTrackElitePlansScreenLoadWhenReady(!showEliteDashboard && !isStatusLoading)

  return (
    <ElitePlansTabbedPageLayout>
      {showEliteDashboard ? <ElitePlansEliteMemberDashboard /> : <ElitePlansSellBody />}
    </ElitePlansTabbedPageLayout>
  )
}
